<template>
    <div class="profile">

        <!-- outer layout -->
        <div class="row">
            <!-- input fields -->
            <div class="col-9">
                <div class="row">
                    <div class="col-4">
                        <label>{{nametext}} *</label>
                        <input type="text"
                               class="form-control"
                               :placeholder="firstnametext"
                               required
                               v-model="memberRecord.first_name"
                        />
                    </div>
                    <div class="col-3">
                        <label>&nbsp;</label>
                        <input type="text"
                               class="form-control"
                               v-model="memberRecord.infix"
                        />
                    </div>
                    <div class="col-5">
                        <label>&nbsp;</label>
                        <input type="text"
                               class="form-control"
                               :placeholder="lastnametext"
                               required
                               v-model="memberRecord.last_name"
                        />

                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label>{{emailtext}} *</label>
                        <input type="text"
                               class="form-control"
                               required
                               v-model="memberRecord.email"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label>{{telephonetext}} 1 ({{optionaltext}})</label>
                        <input type="text"
                               class="form-control"
                               v-model="memberRecord.telephone1"
                        />
                    </div>
                    <div class="col-6">
                        <label>{{telephonetext}} 2 ({{optionaltext}})</label>
                        <input type="text"
                               class="form-control"
                               v-model="memberRecord.telephone2"
                        />

                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <label>{{birthdaytext}} *</label>
                        <input type="text"
                               class="form-control"
                               required
                               :placeholder="daytext"
                               v-model="birth_day"
                        />
                    </div>
                    <div class="col-3">
                        <label>&nbsp;</label>
                        <input type="text"
                               class="form-control"
                               required
                               :placeholder="monthtext"
                               v-model="birth_month"
                        />
                    </div>
                    <div class="col-6">
                        <label>{{birthyeartext}} ({{optionaltext}})</label>
                        <input type="text"
                               class="form-control"
                               v-model="birth_year"
                        />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <input
                            id="receive-email"
                            type="checkbox"
                            class="custom-checkbox"
                            v-model="email_subscription"
                        >
                        <label for="receive-email">{{emailupdatestext}}</label>
                        <small>{{emailupdatesexplaintext}}</small>
                    </div>
                </div>
            </div>

            <!-- avatar edit -->
            <div class="col-3">
                <div class="row">
                    <div class="col">
                        <div class="yf-imgcontainer" :title="changeprofilephototext">
                            <!-- get photo -->
                            <img class="yf-avatar" :src="avatarUrl" />
                            <!-- edit button rendered on top -->
                            <a class="btn btn-success yf-img-btn"><i class="fa fa-edit"></i></a>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-12">
                        <button class="btn btn-success" data-target="#updatepw" data-toggle="modal">
                            <i class="fa fa-key"></i>
                            {{changepwtext}}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Save -->
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <button class="btn btn-success"
                                @click.prevent="saveProfile"
                                :disabled="!datasaveable">
                            <i class="fa fa-save"></i>
                            {{okbuttontext}}
                        </button>
                        <span class="text-success" v-if="successmsg !== ''">{{successmsg}}</span>
                        <span class="text-danger" v-if="errormsg !== ''">{{errormsg}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- POPUP: reset password -->
        <div class="modal fade" id="updatepw" tabindex="-1"
             role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content yf-popup-background">
                    <div class="modal-header">
                        <h5 class="modal-title">{{changepwtext}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{currentpassword}} *</label>
                                    <input :type="showPwFields ? 'text' : 'password'"
                                           class="form-control"
                                           required
                                           v-model="changePwCurrentPassword"
                                    />
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{newpassword}} *</label>
                                    <input :type="showPwFields ? 'text' : 'password'"
                                           class="form-control"
                                           required
                                           v-model="changePwNewPassword1"
                                    />
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{repeatnewpassword}} *</label>
                                    <input :type="showPwFields ? 'text' : 'password'"
                                           class="form-control"
                                           required
                                           v-model="changePwNewPassword2"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 small-line-height">
                                <small>{{explainpwrequirements}}</small>
                            </div>
                        </div>
                        <br/>
                        <div class="row">
                            <div class="col-12">
                                <small v-if="messagepw !== '' && (changePwNewPassword2.length <= 7)" class="alert alert-info">{{messagepw}}</small>
                                <small v-if="messagepw !== '' && (changePwNewPassword2.length > 7)" class="alert alert-danger">{{messagepw}}</small>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!-- button block -->
                        <button type="button" class="btn btn-sm btn-outline-info float-left"
                                @click.prevent="togglePwFields">
                            {{togglepasswordfield}}
                        </button>
                        <button type="button" class="btn btn-secondary"
                                data-dismiss="modal">
                            {{closebuttontext}}
                        </button>
                        <button type="button" class="btn btn-primary"
                                data-dismiss="modal" @click.prevent="saveChangePassword"
                                :disabled="!changPasswordSavable">
                            {{okbuttontext}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div> <!-- END .profile-->
</template>

<script>

    import {isValidEmail} from '../yf-jsmodules';

    export default {
        data() {
            return {
                memberRecord: window.membersAsJson,
                birth_day: '',
                birth_month: '',
                birth_year: '',
                email_subscription: false,
                successmsg: '',
                errormsg: '',
                changePwCurrentPassword: '',
                changePwNewPassword1: '',
                changePwNewPassword2: '',
                messagepw: '',
                showPwFields: false
            }
        },

        /**
         * Setup inital values
         */
        mounted() {
            this.birth_day = this.memberRecord.birth_date.substr(2,2);
            this.birth_month = this.memberRecord.birth_date.substr(0,2);
            this.birth_year = this.makeValidBirthYear();
            // string2bool
            this.email_subscription = this.memberRecord.email_subscription === '1';
        },

        methods: {
            /**
             * Save profile to backend
             */
            saveProfile() {
                // prep data
                const data = {
                    'first_name': this.memberRecord.first_name,
                    'infix': this.memberRecord.infix,
                    'last_name': this.memberRecord.last_name,
                    'email': this.memberRecord.email,
                    'telephone1': this.memberRecord.telephone1,
                    'telephone2': this.memberRecord.telephone2,
                    'birth_day': this.birth_day,
                    'birth_month': this.birth_month,
                    'birth_year': this.birth_year,
                    'email_subscription': this.email_subscription,
                    'introtext': this.memberRecord.description
                };

                // save to WP backend (which saves to Yfantis DB)
                axios.put(window.apiUrl + '/' + this.memberRecord.id + '?_wpnonce=' + window.wpnonce, data)
                    .then(resp => {
                        // success: set user message
                        this.errormsg = '';
                        this.successmsg = resp.data.msg;
                        setTimeout(() => {
                            this.successmsg = '';
                        }, 2000);
                    })
                    .catch(err => {
                        // error: set user message
                        this.errormsg = err.data.error;
                        this.successmsg = '';
                        setTimeout(() => {
                            this.errormsg = '';
                        }, 2000);
                    })
            },

            saveChangePassword () {
                const data = {
                    oldpw: this.changePwCurrentPassword,
                    newpw: this.changePwNewPassword1
                }
                // save to WP backend (which saves to Yfantis DB)
                axios.put(window.apiUrlChPw + '/' + this.memberRecord.id + '?_wpnonce=' + window.wpnonce, data)
                    .then(resp => {
                        // success: set user message
                        this.errormsg = '';
                        this.successmsg = resp.data.message;
                        setTimeout(() => {
                            this.successmsg = '';
                        }, 2000);
                    })
                    .catch(err => {
                        // error: set user message
                        this.errormsg = err.message;
                        this.successmsg = '';
                        setTimeout(() => {
                            this.errormsg = '';
                        }, 2000);
                    });
            },

            /**
             * validate the value for birth_year (db value)
             * should be integer between 1900 and current year
             * function can also be used before saving
             */
            makeValidBirthYear() {
                let currentValue = parseInt(this.memberRecord.birth_year);
                let currentYear = new Date().getFullYear();
                return ( typeof currentValue < 1900 || currentValue > currentYear)
                    ? ''
                    : currentValue;
            },
            togglePwFields () {
                this.showPwFields = !this.showPwFields
            },
            checkNewPassword () {
                this.messagepw = '';
                let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
                if(this.changePwNewPassword1 !== '') {
                    if (!strongRegex.test(this.changePwNewPassword1)) {
                        this.messagepw = this.messagepwnotstrongenoughyet;
                    } else if (this.changePwNewPassword1 !== this.changePwNewPassword2) {
                        this.messagepw = this.messagepw1notyetequalpw2;
                    }
                }
            }
        },
        computed: {
            datasaveable() {
                console.log('Validating...');
                let birthday = parseInt(this.birth_day);
                let birthmonth = parseInt(this.birth_month);
                console.log(`month: ${birthmonth}`);
                if(!this.memberRecord.first_name.length > 0) {
                    console.log("firstname empty")
                }
                if(!this.memberRecord.last_name.length > 0) {
                    console.log("lastname empty")
                }
                if(!this.memberRecord.email.length > 0) {
                    console.log("email empty")
                }
                if(!isValidEmail(this.memberRecord.email)) {
                    console.log("email invalid")
                }
                if (!(birthday > 0 && birthday < 32)) {
                    console.log("birth day invalid")
                }
                if (!(birthmonth > 0 && birthmonth < 13)) {
                    console.log("birth month invalid")
                }
                return this.memberRecord.first_name.length > 0 &&
                this.memberRecord.last_name.length > 0 &&
                this.memberRecord.email.length > 0 &&
                isValidEmail(this.memberRecord.email) &&
                birthday > 0 && birthday < 32 &&
                birthmonth > 0 && birthmonth < 13;
            },
            changPasswordSavable () {
                let p2Empty = this.changePwNewPassword2 === '';
                let cpEmpty = this.changePwCurrentPassword === '';
                let msgEmpty = this.messagepw === '';
                console.log(`${p2Empty} / ${cpEmpty} / ${msgEmpty}, verdict: ${!p2Empty && !cpEmpty && msgEmpty}`);
                return (
                    !p2Empty && !cpEmpty && msgEmpty
                );
            },
            avatarUrl () {
                return window.avatarUrl;
            }

        },
        watch: {
            changePwNewPassword1() {
                this.checkNewPassword()
            },
            changePwNewPassword2() {
                this.checkNewPassword()
            }
        },
        props: {
            okbuttontext: {
                type: String,
                required: true
            },
            closebuttontext: {
                type: String,
                required: true
            },
            togglepasswordfield: {
                type: String,
                required: true
            },
            changepwtext: {
                type: String,
                required: true
            },
            currentpassword: {
                type: String,
                required: true
            },
            newpassword: {
                type: String,
                required: true
            },
            repeatnewpassword: {
                type: String,
                required: true
            },
            hidefields: {
                type: String,
                required: true
            },
            showfields: {
                type: String,
                required: true
            },
            explainpwrequirements: {
                type: String
            },
            messagepwnotstrongenoughyet: {
                type: String,
                required: true
            },
            messagepw1notyetequalpw2: {
                type: String,
                required: true
            },
            firstnametext: {
                type: String,
                required: true
            },
            lastnametext: {
                type: String,
                required: true
            },
            nametext: {
                type: String,
                required: true
            },
            emailtext: {
                type: String,
                required: true
            },
            telephonetext: {
                type: String,
                required: true
            },
            optionaltext: {
                type: String,
                required: true
            },
            daytext: {
                type: String,
                required: true
            },
            monthtext: {
                type: String,
                required: true
            },
            birthdaytext: {
                type: String,
                required: true
            },
            birthyeartext: {
                type: String,
                required: true
            },
            emailupdatestext: {
                type: String,
                required: true
            },
            emailupdatesexplaintext: {
                type: String,
                required: true
            },
            changeprofilephototext: {
                type: String,
                required: true
            },
            webintrotext: {
                type: String,
                required: true
            },
        }
    };
</script>

<style scoped>
    .yf-imgcontainer {
        position: relative;
    }
    .yf-imgcontainer img {
        display: block;
    }
    .yf-imgcontainer .yf-img-btn {
        display: none; /* even niet tonen tot we upload voor elkaar hebben*/
        position: absolute; bottom:0; left:0;
    }
    .yf-popup-background {
        background-color: #dee2e6
    }
    .twbs .modal-header {
        border-bottom-color: black;
    }
    .twbs .modal-footer {
        border-top-color: black;
    }
    .small-line-height {
        line-height: 80%;
    }
    .twbs .yf-avatar {
        border-radius: 5px;
    }
</style>
